const initialState = {
  settings: [],
  totalSettings: 0,
  currentSettingPage: 0,
  selectedSetting: null,
  projectDetail: null,
  dbExportRequestList: null,
  exportRequestList: null,
  permissionFlags: null,
  codeDownloadHistories: [],
  enableCodeExport: false,
  githubUserData: null,
  githubRepoData: [],
  githubExportList: [],
  listDeploymentSettingPending: false,
  listDeploymentSettingError: null,
  createDeploymentSettingPending: false,
  createDeploymentSettingError: null,
  deleteDeploymentSettingPending: false,
  deleteDeploymentSettingError: null,
  updateDeploymentSettingPending: false,
  updateDeploymentSettingError: null,
  publishDeploymentSettingPending: false,
  publishDeploymentSettingError: null,
  loadProjectDepSettingPending: false,
  loadProjectDepSettingError: null,
  loadDumpRequestListPending: false,
  loadDumpRequestListError: null,
  loadCodeExportRequestListPending: false,
  loadCodeExportRequestListError: null,
  loadPermissionFlagsPending: false,
  loadPermissionFlagsError: null,
  exportProjectCodePending: false,
  exportProjectCodeError: null,
  deleteExportRequestPending: false,
  deleteExportRequestError: null,
  loadDownloadCodeHistoryPending: false,
  loadDownloadCodeHistoryError: null,
  requestUpgradeAccountPending: false,
  requestUpgradeAccountError: null,
  saveDbExportRequestPending: false,
  saveDbExportRequestError: null,
  deleteDbExportRequestPending: false,
  deleteDbExportRequestError: null,
  downloadDbDumpPending: false,
  downloadDbDumpError: null,
  loadDbExportRequestListPending: false,
  loadDbExportRequestListError: null,
  loadGithubUserDataPending: false,
  loadGithubUserDataError: null,
  pushToGitHubPending: false,
  pushToGitHubError: null,
};

export default initialState;
